<template>
    <f7-page
        id="start"
        :page-content="false"
        name="Start"
        navbar-hidden
        no-navbar
        class="onboardingBg"
    >

        <f7-swiper
            id="onboardingSwiper"
            :params="{touchReleaseOnEdges: true, parallax: true}"
        >
            <div
                slot="before-wrapper"
                class="parallax-bg"
                data-swiper-parallax="-30%"
            />
            <div
                slot="before-wrapper"
                class="parallax-bg-3"
                data-swiper-parallax="-60%"
            />
            <div
                slot="before-wrapper"
                class="parallax-bg-2"
                data-swiper-parallax="-30%"
            />

            <f7-swiper-slide>
                <div
                    class="vcenter"
                    style="z-index: 10000; position: relative; height: 100vh; overflow: hidden"
                >
                    <div style="position: relative">
                        <transition
                            name="slide-fade"
                            appear
                        >
                            <svg
                                id="logoSvg"
                                width="200px"
                                data-swiper-parallax="-100"
                                viewBox="0 0 432 162"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                                <path
                                    fill="black"
                                    d="M125.07,55.31c-1.45,3.77-2.36,6.07-3.19,6-.33,0-1-.69-1.11-1.53-6-19.45-22.11-25.6-39-26.14-30.19-1-48,20.25-48.89,49.77-.91,28.87,14.24,53.76,45.43,54.74,22.06.7,36.48-9,42.66-20.41.77-1,1.93-3.12,2.83-4.69a1.19,1.19,0,0,1,2.12.12c1.5,3.45,4.5,9.33,5.65,11.57a1.2,1.2,0,0,1-.35,1.51l-4.48,3.3c-13.91,9.36-31,13.3-47.73,12.77-32.18-1-65.09-21.14-64-57C16.2,48.06,47.7,28.46,82,29.54c17.76.56,33.28,5.86,45.8,15.7a1.23,1.23,0,0,1,.38,1.37Z"
                                />
                                <path
                                    fill="black"
                                    d="M180.77,51.13c25.07,0,49.13,18.25,49.13,45.64s-24.06,45.64-49.13,45.64-49.12-18.26-49.12-45.64S155.71,51.13,180.77,51.13Zm0,87.13c24.57,0,33.37-18.92,33.2-41.49.17-22.57-8.63-41.5-33.2-41.5s-33.36,18.93-33.19,41.5C147.41,119.34,156.21,138.26,180.77,138.26Z"
                                />
                                <path
                                    fill="black"
                                    d="M279.74,67.72c-2-1.66-4.48-4.31-9-4.31-13.94,0-18.42,16.76-18.42,43v10.13c0,12.28,1.49,20.08,8.13,20.91,1.82.17,2.82.83,2.82,2,0,.83-.5.83-1.33.83-2.82,0-9-.33-14.77-.33s-12,.33-14.77.33c-.83,0-2-.33-2-.83,0-.66,1.16-1.49,2.82-2.15,5.31-2.66,6.8-8.47,6.8-23.74V65.4c0-3.32-2.82-5.48-5.64-6.47-1.33-.34-2.49-1-2.49-1.33s1-.67,2.16-1L251.36,52V75.19h.33c7.47-16.26,17.26-24.06,33.69-24.06Z"
                                />
                                <path
                                    fill="black"
                                    d="M370.69,115c0,10.46,1.33,21.25,5.81,22.74.83.34,1.33.83,1.33,1.33a1.35,1.35,0,0,1-1.5,1.16c-.66,0-4.65-.33-6.47-.33-2.16,0-4.32.33-6.14.33-1.33,0-2-.83-2-1.32,0-4.15-2.33-11-2.82-15.61h-.34c-7.13,14.28-19.75,19.09-35,19.09-16.1,0-35.35-8.46-35.35-26.56,0-25.39,37.84-29.21,56.6-29.21h12.61c0-19.42-5.48-31.37-26.56-31.37-11.61,0-30.37,6.31-31.86,19.42,0,.5-.33.67-.83.67-.33,0-.5,0-.67-.5L293,59.09a96.52,96.52,0,0,1,37.35-8c30.2,0,40.33,13.11,40.33,32.36ZM345.13,90.79c-17.59,0-41,3.32-41,25.4,0,14.6,11.29,22.07,24.73,22.07,24.9,0,28.55-19.92,28.55-40.16V90.79Z"
                                />
                                <path
                                    fill="black"
                                    d="M407.38,115.85c0,9.63.83,19.42,6.14,21.58,1.66.67,3.49,1.33,3.49,2.16,0,.5-2,.66-2.82.66-2,0-8.14-.33-12.95-.33s-10.95.33-13.77.33c-3,0-3.66-.16-3.66-.66,0-.83,2.16-1.49,4.49-2.49,6-2.66,6.8-17.1,6.8-34.36V43.82c0-12.45-1.33-16.1-5.81-17.76-1.16-.33-1.66-.66-1.66-1,0-.5.83-.83,1.5-1l18.25-4.48Z"
                                />

                            </svg>
                        </transition>
                    </div>
                </div>

            </f7-swiper-slide>
            <f7-swiper-slide>
                <div
                    class="vcenter"
                    style="z-index: 1000; position: relative"
                >
                    <div>
                        <h2
                            class="slide-title"
                            style="margin-top: -160px; max-width: 400px;"
                            v-html="'Sex and intimacy are fundamental to your health and happiness'"
                        />
                        <p class="subtitle" />
                    </div>
                </div>

            </f7-swiper-slide>
            <f7-swiper-slide>
                <div
                    style="z-index: 1000; "
                    class="vcenter"
                >
                    <div style="height: 380px; margin-top: -100px">
                        <h2
                            class="slide-title"
                            v-html="'Wellness<br>is all about balance<br>'"
                        />
                        <div :class="`render-${render} ball-box`">
                            <transition
                                name="slide-fade"
                                appear
                            >
                                <img
                                    v-show="showBall[0]"
                                    src="../../img/1.2.0/blueBall.png"
                                    class="balls"
                                    style="position: absolute; transform: translateX(0px); width: 95px; height: 95px; left: 27px; top: 151px;"
                                >
                            </transition>
                            <transition
                                name="slide-fade"
                                appear
                            >
                                <img
                                    v-show="showBall[1]"
                                    src="../../img/1.2.0/darkBall.png"
                                    class="balls"
                                    style="position: absolute;  transform: translateX(0px); width: 94px; height: 94px; left: 3px; top: 70px; opacity: 0.8;"
                                >
                            </transition>
                            <transition
                                name="slide-fade"
                                appear
                            >
                                <img
                                    v-show="showBall[2]"
                                    src="../../img/1.2.0/greenBall.png"
                                    style="position: absolute;  transform: translateX(0px); width: 94px; height: 94px; left: 115px; top: 152px; opacity: 0.8;"
                                >
                            </transition>
                            <transition
                                name="slide-fade"
                                appear
                            >
                                <img
                                    v-show="showBall[3]"
                                    src="../../img/1.2.0/grayBall.png"
                                    class="balls"
                                    style="position: absolute;  transform: translateX(0px); width: 94px; height: 95px; left: 139px; top: 70px; opacity: 0.8;"
                                >
                            </transition>
                            <transition
                                name="slide-fade"
                                appear
                            >
                                <img
                                    v-show="showBall[4]"
                                    src="../../img/1.2.0/redBall.png"
                                    class="balls"
                                    style="position: absolute;  transform: translateX(0px);  width: 94px; height: 93.12px; left: 70px; top: 14px; opacity: 0.95;"
                                >
                            </transition>

                        </div>
                        <br>
                        <transition
                            name="slide-fade"
                            appear
                        >
                            <h2
                                v-show="showBall[5]"
                                class="slide-title"
                                v-html="'but sex is frequently<br>overlooked'"
                            />
                        </transition>
                    </div>
                </div>
                <!-- <div class="sk-asset slide-2" /> -->
                <!-- <div class="sk-asset slide-2-ball" /> -->
            </f7-swiper-slide>
            <f7-swiper-slide>
                <div
                    class="vcenter"
                    style="z-index: 1000; position: relative"
                >
                    <div>
                        <h2
                            class="slide-title"
                            style="margin-top: -110px; max-width: 300px;"
                            v-html="'Coral coaches you to achieve your best intimate life'"
                        />
                        <!--  through science, inspiration & exercises -->
                        <p class="subtitle" />
                    </div>
                </div>

            </f7-swiper-slide>
        </f7-swiper>

        <div class="absBottom safe-area-bottom">
            <div style="margin: -100px auto 0px; max-width: 260px">
                <f7-button
                    color="red"
                    round
                    fill
                    @click="buttonContinue"
                >{{ buttonText }}</f7-button>
            </div>
            <f7-link
                v-if="slide === 1"
                href="/login"
                class="minorActions safe-area-bottom"
            >SIGN IN</f7-link>
            <div
                v-if="slide === 1"
                class="styleLine"
            />
        </div>

    </f7-page>
</template>

<script>
export default {
    data () {
        return {
            buttonText: 'Sign up',
            showBall: [false, false, false, false, false, true],
            value: '',
            show: false,
            slide: 1,
            render: 0,
            myTopicsBuilt: false
        };
    },
    store: ['api', 'user'],
    computed: {},
    created: function () {
        let panel = f7.panel.get('.panel-left');
        panel.params.visibleBreakpoint = 768;
        panel.disableVisibleBreakpoint();
    },
    mounted: function () {
        let checkSlide = () => {
            const swiper = $$('#onboardingSwiper')[0].swiper;
            swiper.on('slideChange', () => {
                this.buttonText = swiper.activeIndex === 0 ? 'Sign up' : 'Continue';
                if (swiper.activeIndex)
                    this.buttonText = swiper.activeIndex === 3 ? 'Dive In' : 'Continue';
                if (swiper.activeIndex === 2) {
                    console.log('show')
                    for (let i = 0; i < this.showBall.length + 1; i++) {
                        setTimeout(() => {
                            console.log('show', i)
                            this.showBall[i] = true;
                            this.render++;
                        }, 300 * (i + 1));
                    }
                }
                this.slide = swiper.activeIndex + 1;
            });
        };
        setTimeout(() => {
            if ($$('#onboardingSwiper') && $$('#onboardingSwiper')[0]) checkSlide();
            else
                setTimeout(() => {
                    if ($$('#onboardingSwiper') && $$('#onboardingSwiper')[0]) checkSlide();
                }, 1000);
        }, 200);
        setTimeout(() => {
            if (!navigator.onLine) {
                this.goOfflineWeb();
            }
        }, 300);
        setTimeout(() => {
            if (!pgap && this.user.id && location.hostname !== "localhost") {
                // failsafe for web mostly
                f7.views['main'].router.navigate('/home', { reload: true, animatePages: false });
            }
        }, 1000);
    },
    methods: {
        initBreakpoints: function () {
            let panel = f7.panel.get('.panel-left');
            panel.params.visibleBreakpoint = 768;
            panel.enableVisibleBreakpoint();
        },
        goOfflineWeb: function () {
            console.log('Go Offline');
            $$('#main').hide();
            $$('#offline').show();
            f7.views['offline'].router.navigate('/offline', { reload: true, animatePages: false });
        },
        buttonContinue: function () {
            if (!$$('#onboardingSwiper') || !$$('#onboardingSwiper')[0]) return;
            const swiper = $$('#onboardingSwiper')[0].swiper;
            if (this.slide === 4) {
                this.buttonLast();
            } else {
                if (swiper) swiper.slideNext();
            }
        },
        buttonLast: function () {
            f7.views['main'].router.navigate('/register');
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.swiper-slide {
    width: 100vh;
    height: 100%;
    h1,
    h2,
    h3,
    p {
        padding: 0 44px;
        margin: 10px 0px;
        text-align: center;
        -webkit-backface-visibility: hidden;
        -webkit-transform: translate3d(0, 0, 0);
    }
    p {
        margin: 0px;
    }
}
.ball-box {
    width: 236px;
    height: 260px;
    transform: translateX(-50%);
    display: inline-block;
    margin: 0px auto;
    position: relative;
    left: 50%;
}
.balls {
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
}
.parallax-bg-2 {
    position: absolute;
    left: calc(~'-800px' + 50vw);
    bottom: -50px;
    background: url(../../img/1.2.0/onboarding_bottom.png) bottom left no-repeat;
    background-size: 5954.5px 804px;
    height: 804px;
    width: 5954.5px;
}
.parallax-bg-3 {
    position: absolute;
    left: calc(~'400px' + 50vw);
    bottom: -98px;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_bottom2.png) bottom left
        no-repeat;
    background-size: 1476px 535.5px;
    height: 535.5px;
    width: 1476px;
}
.styleLine {
    border-right: 1px solid #000;
    width: 50vw;
    height: 50px;
    position: absolute;
    bottom: -40px;
}
.minorActions {
    width: 100%;
    font-family: AndesMedium;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 13px !important;
    color: #000;
    height: 100px;
    text-align: center;
    line-height: 12px;
}
.swiper-wrapper {
    height: 100%;
}

.ion-checkmark-circled {
    color: @green;
    font-size: 30px;
    line-height: 16px;
}
.ion-ios-circle-outline {
    font-size: 30px;
    line-height: 16px;
}
.slide-title {
    font-family: Editor-Bold !important;
    font-weight: bold !important;
    font-size: 28px;
    letter-spacing: -1px;
    color: #000000;
    text-align: center;
    line-height: 31px;
    .emphasis {
        color: #000000;
    }
    max-width: 600px;
    margin: 0 auto;
}
@media only screen and (max-height: 720px) {
    .slide-title {
        font-size: 20px;
        line-height: 21px;
    }
}
.absBottom {
    overflow: visible;
    text-align: center;
    position: absolute;
    z-index: 100000;
    bottom: 50px;
    width: 100%;
    margin: 0;
    a.minorActions {
        cursor: pointer;
        margin: 0px auto;
        line-height: 55px;
        padding: 0;
        height: 55px;
        font-size: 13px;
        &.ansButton {
            font-size: 13px;
        }
    }
}

.ios.device-iphone-x .logo {
    padding-top: 40px;
}
.vcenter {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -40px;
}
.ios.device-iphone-x .absBottom {
    bottom: 16px !important;
}
.ios.device-iphone-x .vcenter {
    margin-top: -70px;
}
.minorActions.safe-area-bottom.link {
    height: 100px;
    padding-bottom: 50px;
    margin-bottom: -50px;
}
#logoSvg {
    left: 50%;
    margin-left: -100px;
    top: -230px;
    position: absolute;
}
@media only screen and (min-width: 750px) and (min-height: 850px) {
    #logoSvg {
        top: -370px;
    }
}
</style>
